// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5f191c84","360":"9c577c39","581":"bce887be","870":"583a7bdc"}[chunkId] + ".chunk.js";
};